import React from "react"

export default function NoHeart() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
         <circle cx="15.0576" cy="15.8711" r="15" fill="white" />
         <g clipPath="url(#clip0_94_14834)">
            <path d="M18.5825 9.87109C17.3075 9.87109 16.0325 10.4711 15.2075 11.4461C14.3825 10.4711 13.1075 9.87109 11.8325 9.87109C11.4575 9.87109 11.0825 9.94609 10.7075 10.0211L12.0575 11.3711C13.1075 11.4461 14.0825 12.1961 14.4575 13.0961H15.8825C16.3325 12.1211 17.4575 11.3711 18.5825 11.3711C20.0825 11.3711 21.2075 12.4961 21.2075 13.9961C21.2075 15.3461 20.3075 16.6211 18.8825 18.1211L19.9325 19.1711C21.6575 17.3711 22.7075 15.7211 22.7075 13.9211C22.7075 11.6711 20.9075 9.87109 18.5825 9.87109Z" fill="#B8BAC2" />
            <path d="M8.60762 10.0215L7.55762 11.0715L8.30762 11.8215C7.93262 12.4965 7.70762 13.1715 7.70762 13.9965C7.70762 16.8465 10.2576 19.1715 14.0826 22.6215L15.2076 23.5965L16.3326 22.6215C16.8576 22.1715 17.3076 21.7215 17.8326 21.2715L19.3326 22.7715L20.3826 21.7215L8.60762 10.0215ZM15.2826 21.4965L15.2076 21.6465L15.1326 21.5715C11.5326 18.2715 9.20762 16.1715 9.20762 13.9965C9.20762 13.6215 9.28262 13.2465 9.43262 12.9465L16.7076 20.2215C16.2576 20.6715 15.8076 21.1215 15.2826 21.4965Z" fill="#B8BAC2" />
         </g>
         <defs>
            <clipPath id="clip0_94_14834">
               <rect width="18" height="18" fill="white" transform="translate(6.05762 6.87109)" />
            </clipPath>
         </defs>
      </svg>
   )
}
